import React from 'react';
import { CampaignDetailView } from '@/domains/campaigns';

const CampaignDetailPage: React.FC = () => {
  return <CampaignDetailView />;
};

export default CampaignDetailPage;
